import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { enable2FAApi, verify2FASetupApi } from "../../redux/apiCalls/authApiCall";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";

function Enable2FA() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { user } = useSelector(state => state.auth);

  const [qrData, setQrData] = useState("");
  const [token, setToken] = useState("");
  const [loading, setLoading] = useState(false);

  // 1️⃣ Get QR Code and Temp Secret
  useEffect(() => {
    if(!user) return navigate("/login");

    const fetchQr = async () => {
      setLoading(true);
      try {
        const data = await dispatch(enable2FAApi());
        setQrData(data.qrData);
      } catch (err) {
        toast.error(err.message || "Failed to generate QR");
      }
      setLoading(false);
    };

    fetchQr();
  }, [dispatch, user, navigate]);

  // 2️⃣ Verify the code
  const submitHandler = async (e) => {
    e.preventDefault();
    if(token.trim() === "") return toast.error("Code is required");

    setLoading(true);
    try {
      await dispatch(verify2FASetupApi(token));
      toast.success("2FA enabled successfully!");
      navigate("/users/profile/" + user._id); // back to profile
    } catch (err) {
      toast.error(err.message || "Invalid code");
    }
    setLoading(false);
  };

  return (
    <main style={{display:"flex",justifyContent:"center",marginTop:"50px"}}>
      <ToastContainer position="top-center" theme="colored" />
      <div style={{padding:"20px",border:"1px solid #ccc",borderRadius:"8px",textAlign:"center"}}>
        <h2>Enable Two-Factor Authentication</h2>

        {loading && <p>Loading...</p>}

        {qrData && (
          <>
            <p>Scan this QR code with Authenticator App</p>
            <img src={qrData} alt="2FA QR Code" style={{width:"200px", margin:"20px 0"}} />
            <form onSubmit={submitHandler}>
              <input
                type="text"
                placeholder="Enter 6-digit code"
                value={token}
                onChange={(e) => setToken(e.target.value)}
                maxLength={6}
                style={{padding:"8px",fontSize:"16px"}}
              />
              <br/><br/>
              <button type="submit" style={{padding:"10px 20px",fontSize:"16px"}}>
                Verify & Enable
              </button>
            </form>
          </>
        )}
      </div>
    </main>
  );
}

export default Enable2FA;